import vars from '../helpers';

const init = () => {
	const $test = vars.$document.find('.js-test');

	if (!$test.length) {
		return;
	}

	const $steps = $test.find('.js-test-steps');
	const $firstStep = $test.find('.js-test-step[data-step="1"]');
	const $results = $test.find('.js-test-results');
	const $restart = $test.find('.js-test-restart');
	const $checkboxes = $test.find('.js-test-checkbox');
	const $checkboxesContainer = $test.find('.js-test-checkboxes');
	const $points = $results.find('.js-test-result-points');
	const $text = $results.find('.js-test-result-text');
	const $testStep = $test.find('.test__steps .test__step').last();
	const $testQuestion = $testStep.find('.test__finish .test__to-question span');

	$testQuestion.text('Результаты');

	let actualStep = 1;
	let points = 0;
	let grade = 'middle';
	let text = 'правильных ответов';

	let tl1 = gsap.timeline();
	let duration = 0.5;
	let delay = duration;

	const startAnimation = (obj) => {
		if (vars.isMobile()) {
			return;
		}

		let $step = $test.find(`.js-test-step[data-step="${actualStep}"]`);
		let $start = $step.find('.js-test-step-start');
		let $imageBack = $step.find('.js-test-image-back');
		let $imageFront = $step.find('.js-test-image-front');
		let $imageHero = $step.find('.js-test-image-hero');

		obj
			.from($start, {
				duration,
				right: '-100%',
				clearProps: 'all',
			}, delay * 2)
			.from($imageBack, {
				duration,
				autoAlpha: 0,
				clearProps: 'all',
			}, actualStep === 6 ? delay * 3 : delay * 2)
			.from($imageFront, {
				duration,
				autoAlpha: 0,
				clearProps: 'all',
			}, actualStep === 6 ? delay * 2 : delay * 3)
		;

		if (actualStep === 1) {
			obj
				.from($imageHero, {
					duration,
					top: '100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 2) {
			obj
				.from($imageHero, {
					duration: duration * 2,
					left: '-100%',
					scale: '0.25',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 3) {
			obj
				.from($imageHero, {
					duration: duration * 2,
					left: '-100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 4) {
			obj
				.from($imageHero, {
					duration: duration * 2,
					left: '-100%',
					top: '-100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 5) {
			obj
				.from($imageHero, {
					duration,
					top: '100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 6) {
			obj
				.from($imageHero, {
					duration,
					top: '100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 7) {
			obj
				.from($imageHero, {
					duration,
					top: '100%',
					clearProps: 'all',
				}, delay * 4)
			;
		} else if (actualStep === 8) {
			obj
				.from($imageHero, {
					duration,
					top: '100%',
					clearProps: 'all',
				}, delay * 4)
			;
		}
	};

	tl1
		.from($test, {
			duration: vars.isMobile() ? duration * 2 : duration,
			autoAlpha: 0,
			onStart() {
				$test.removeClass('is-hidden');
				$firstStep.removeClass('is-hidden');
			},
			clearProps: 'all',
		}, delay)
	;

	if (!vars.isMobile()) {
		tl1
			.from($checkboxesContainer, {
				duration,
				autoAlpha: 0,
				clearProps: 'all',
			}, delay * 2)
		;

		startAnimation(tl1);
	}

	const toTopScreen = () => {
		if (!vars.isMobile()) {
			return;
		}

		gsap.to(window, {
			duration,
			scrollTo: 0,
		});
	};

	const action = (step = actualStep) => {
		let $step = $test.find(`.js-test-step[data-step="${step}"]`);
		let $toQuestion = $step.find('.js-test-step-to-question');
		let $start = $step.find('.js-test-step-start');
		let $content = $step.find('.js-test-step-content');
		let $answers = $step.find('.js-test-step-answer');
		let $answerQuestion = $step.find('.js-test-step-answer-question');
		let $finish = $step.find('.js-test-step-finish[data-result="false"]');
		let $nextQuestion = $step.find('.js-test-step-next-question');
		let $stars = $step.find('.js-test-image-stars');

		let hit = false;

		$toQuestion.one('click.step', () => {
			toTopScreen();

			let tl = gsap.timeline();

			tl
				.to($start, {
					autoAlpha: vars.isMobile() ? 0 : 1,
					right: vars.isMobile() ? 0 : '-100%',
					duration,
					onComplete() {
						$start.addClass('is-hidden');
					},
					clearProps: 'all',
				})
				.from($content, {
					autoAlpha: vars.isMobile() ? 0 : 1,
					right: vars.isMobile() ? 0 : '-100%',
					duration,
					onStart() {
						$content.removeClass('is-hidden');
					},
					clearProps: 'all',
				}, delay)
			;

			const $stepNumber = $step.data('step');
			const $steQuestion = $step.find('.test__question').text();

			ga('send', 'event', 'test', 'question show num', 'name', {nonInteraction: true});

			ym(93591439, 'reachGoal', 'question show', {
				'question show': {
					[$stepNumber]: $steQuestion,
				},
			});
		});

		$answers.one('change.step', () => {
			$answerQuestion
				.data('enable', 'true')
				.attr('data-enable', 'true');
		});

		$answerQuestion.one('click.step', () => {
			toTopScreen();

			if ($step.find('.js-test-step-answer:checked').data('hit')) {
				points++;
				hit = true;

				$finish = $step.find('.js-test-step-finish[data-result="true"]');
				$stars.removeClass('is-hide');
			}

			let $checkbox = $test.find(`.js-test-checkbox[data-step="${actualStep}"]`);

			let tl = gsap.timeline();

			tl
				.to($content, {
					autoAlpha: vars.isMobile() ? 0 : 1,
					right: vars.isMobile() ? 0 : '-100%',
					duration,
					onComplete() {
						$content.addClass('is-hidden');

						$checkbox
							.data('checkbox', hit ? 'success' : 'error')
							.attr('data-checkbox', hit ? 'success' : 'error');

						actualStep++;

						if (actualStep === 9) {
							actualStep = 'finish';
						}

						$answerQuestion
							.data('enable', 'false')
							.attr('data-enable', 'false');
					},
					clearProps: 'all',
				})
				.from($finish, {
					autoAlpha: vars.isMobile() ? 0 : 1,
					right: vars.isMobile() ? 0 : '-100%',
					duration,
					onStart() {
						$finish.removeClass('is-hidden');
					},
					clearProps: 'all',
				}, delay)
			;

			let $path;

			$path = $checkbox.find(`.js-test-checkbox-path--${hit}`);

			$path.each((i, path) => {
				let length = $(path)[0].getTotalLength();

				$(path)[0].style.strokeDasharray = length;
				$(path)[0].style.strokeDashoffset = length;

				tl
					.to($(path), {
						strokeDashoffset: 0,
						duration,
					}, delay * (i + 1))
				;
			});

			// if (!vars.isMobile()) {
			// 	tl
			// 		.from($stars, {
			// 			autoAlpha: 0,
			// 			duration,
			// 			onStart() {
			// 				$stars.removeClass('is-hidden');
			// 			},
			// 			clearProps: 'all',
			// 		}, delay)
			// 	;
			// }

			const $stepNumber = $step.data('step');
			const $stepAnswer = $step.find('.js-test-step-answer:checked').closest('.test__line').find('.test__answer').text();

			ga('send', 'event', 'test', 'question answer num', 'name');

			ym(93591439, 'reachGoal', 'question answer', {
				'question answer': {
					[$stepNumber]: $stepAnswer,
				},
			});
		});

		$nextQuestion.one('click.step', () => {
			toTopScreen();

			let $prev = $step;
			let $next;
			let $result;

			if (actualStep !== 'finish') {
				$next = $test.find(`.js-test-step[data-step="${actualStep}"]`);
			} else {
				$next = $results;
				$prev = $steps;
			}

			if (actualStep === 'finish') {
				if (points < 4) {
					grade = 'low';
				} else if (points > 6) {
					grade = 'high';
				}

				if (points < 5) {
					text = 'правильных ответа';
				}

				if (points === 1) {
					text = 'правильный ответ';
				}

				$result = $results.find(`.js-test-result[data-result="${grade}"]`);
				$points.text(points);
				$text.text(text);

				ga('send', 'event', 'test', 'finish', 'result');
				ga('rbcspec.send', 'event', 'test', 'finish', 'result');

				ym(93591439, 'reachGoal', 'test finish', {
					'test finish': {
						result: points,
					},
				});
			}

			let tl = gsap.timeline();

			tl
				.to($prev, {
					autoAlpha: 0,
					duration,
					onComplete() {
						$prev.addClass('is-hidden');
						$next.removeClass('is-hidden');
						$start.removeClass('is-hidden');
						$step.addClass('is-hidden');
						$finish.addClass('is-hidden');
						// $stars.addClass('is-hidden');
						$stars.addClass('is-hide');

						$answers.each((i, answer) => {
							$(answer).prop('checked', false);
						});

						if (actualStep !== 'finish') {
							action(actualStep);
						} else {
							$result.removeClass('is-hidden');
						}
					},
					clearProps: 'all',
				})
				.from($next, {
					autoAlpha: 0,
					duration,
					clearProps: 'all',
				}, delay)

			;

			if (actualStep === 'finish') {
				if (vars.isMobile()) {
					tl.to($checkboxesContainer, {
						autoAlpha: 0,
						duration,
						onComplete() {
							$checkboxesContainer.addClass('is-hidden');
						},
						clearProps: 'all',
					}, 0);
				}
			} else {
				startAnimation(tl);
			}
		});

		vars.$document.on('step-off', () => {
			$toQuestion.off('.step');
			$answers.off('.step');
			$answerQuestion.off('.step');
			$nextQuestion.off('.step');
		});
	};

	action(1);

	$restart.on('click', () => {
		actualStep = 1;
		points = 0;
		grade = 'middle';
		text = 'правильных ответов';

		toTopScreen();

		let tl = gsap.timeline();

		tl
			.to($results, {
				autoAlpha: 0,
				duration,
				onComplete() {
					vars.$html.trigger('step-off');

					$results.addClass('is-hidden');
					$steps.removeClass('is-hidden');
					$firstStep.removeClass('is-hidden');
					$results.find('.js-test-result:not(.is-hidden)').addClass('is-hidden');
					$checkboxesContainer.removeClass('is-hidden');

					$checkboxes.each((i, checkbox) => {
						$(checkbox)
							.data('checkbox', 'empty')
							.attr('data-checkbox', 'empty');
					});

					action(1);
				},
				clearProps: 'all',
			})
			.from($steps, {
				autoAlpha: 0,
				duration,
				clearProps: 'all',
			}, delay)
			.from($checkboxesContainer, {
				autoAlpha: 0,
				duration,
				clearProps: 'all',
			}, delay)
		;

		ga('send', 'event', 'test', 'resume');

		ym(93591439, 'reachGoal', 'test resume', {
			'test resume': true,
		});

		startAnimation(tl);
	});
};

const destroy = () => {

};

export default {
	init,
	destroy,
};
